import React, { useEffect } from 'react'
import { logos } from '../Assets/Logos/logos'

const LaunchModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return undefined
    }

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open) {
    return null
  }

  return (
    <div className="launch-modal-overlay" onClick={onClose}>
      <div className="launch-modal" onClick={event => event.stopPropagation()}>
        <div className="launch-modal-highlight" />
        <button
          type="button"
          className="launch-modal-close"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>

        <p className="launch-modal-badge">NOVIDADE</p>

        <img
          src={logos.ximedCompleto}
          alt="Logo XIMED Saúde Ocupacional"
          className="launch-modal-logo"
        />

        <h2 className="launch-modal-title">Estamos de cara nova!</h2>
        <p className="launch-modal-text">
          A Casa Ocupacional agora faz parte do grupo XIMED Saúde Ocupacional,
          com a mesma confiança de sempre e ainda mais estrutura para cuidar da
          sua empresa.
        </p>

        <div className="launch-modal-evolution" aria-hidden="true">
          <img
            src={logos.casaOcupacionalBlack}
            alt="Casa Ocupacional"
            className="launch-modal-evolution-casa"
          />
          <div className="launch-modal-arrow-wrap">
            <span className="launch-modal-arrow">→</span>
            <span className="launch-modal-arrow-text">Evoluiu para</span>
          </div>
          <img
            src={logos.ximedCompleto}
            alt="XIMED Saúde Ocupacional"
            className="launch-modal-evolution-ximed"
          />
        </div>

        <a
          href="https://ximed.com.br"
          target="_blank"
          rel="noreferrer"
          className="launch-modal-cta"
        >
          Clique aqui e conheça a XIMED
        </a>
      </div>
    </div>
  )
}

export default LaunchModal
